import React from 'react';

import './styles.css';
import '../styles.css';

import close from '../../../assets/images/close.svg';
import calendar6 from '../../../assets/images/calendar6.svg';
import calendar7 from '../../../assets/images/calendar7.svg';
import calendar8 from '../../../assets/images/calendar8.svg';

const ModalPeriodo = ({ handleClose, setPeriodo }) => {

  const handlePeriodo = (periodo) => {
    setPeriodo(periodo);
    handleClose();
  }

  return (
    <div className="dash-modal">
      <div className="dash-modal-content sm">
        <button className="btn-close" onClick={handleClose}><img src={close} /></button>
        <div className="dash-modal-header">
          <h2 className="text-center">Escolha o período</h2>
        </div>
        <div className="dash-modal-body">
          <div className="btns-periodos">
            <button onClick={() => handlePeriodo('diario')} className="btn-periodo"><img src={calendar6} alt="Icon" />Diário</button>
            <button onClick={() => handlePeriodo('semanal')} className="btn-periodo"><img src={calendar7} alt="Icon" />Semanal</button>
            <button onClick={() => handlePeriodo('mensal')} className="btn-periodo"><img src={calendar8} alt="Icon" />Mensal</button>
          </div>
        </div>
      </div>
    </div>
  );

}

export default ModalPeriodo;